import { AcceptBackupRecordingTermsModal } from '@modals/AcceptBackupRecordingTerms';
import { AddCourseStudentModal } from '@modals/AddCourseStudentModal';
import { AddNewAttorneysAccessModal } from '@modals/AddNewAttorneysAccess';
import { AddWSToTeamModal } from '@modals/AddWSToTeamModal';
import { AddAdminTransactionModal } from '@modals/Admin/AddAdminTransactionModal';
import { AdminAddBalanceToBillingAccountModal } from '@modals/Admin/AddBalanceToBillingAccount';
import { AdminAIModelChoiceModal } from '@modals/Admin/AdminAIModelChoiceModal';
import { AdminBackupFilesModal } from '@modals/Admin/AdminBackupFilesModal';
import { AdminBillingAccountRatesEditorModal } from '@modals/Admin/AdminBillingAccountRatesEditorModal';
import { AdminBulkResubmitJobsModal } from '@modals/Admin/AdminBulkResubmitJobsModal';
import { AdminCloneJobModal } from '@modals/Admin/AdminCloneJobModal';
import { AdminEditJobTranscriptUnlockTypeModal } from '@modals/Admin/AdminEditJobTranscriptUnlockTypeModal';
import { AdminLeaveOrganizationModal } from '@modals/Admin/AdminLeaveOrganizationModal';
import { AdminEditSettingModal } from '@modals/Admin/AdminEditSettingModal';
import { AdminRefundJobModal } from '@modals/Admin/AdminRefundJobModal';
import { AdminApplyEnhancementModal } from '@modals/Admin/AdminApplyEnhancementModal';
import { AdminLlmCallsModal } from '@modals/Admin/AdminLlmCallsModal';
import { AdminResubmitJobModal } from '@modals/Admin/AdminResubmitJobModal';
import { AdminBillingAccountRateModal } from '@modals/Admin/BillingAccountRate';
import { AdminChooseASOneSubscriptionModal } from '@modals/Admin/ChooseASOneSubscription';
import { AdminConfirmSubscription } from '@modals/Admin/ConfirmSubscription';
import { CreateNewAttorneyFeatureFlag } from '@modals/Admin/CreateNewAttorneyFeatureFlag';
import { CreateNewFeatureFlag } from '@modals/Admin/CreateNewFeatureFlag';
import { CreateNewSMSCountry } from '@modals/Admin/CreateNewSMSCountry';
import { SsoProviderModal } from '@modals/Admin/SsoProviderModal';
import { CreateNewWhitelistNumber } from '@modals/Admin/CreateNewWhitelistNumber';
import { EditASOnePlanModal } from '@modals/Admin/EditASOnePlanModal';
import { AdminEditASOneSubscriptionModal } from '@modals/Admin/EditASOneSubscriptionModal';
import { EditAttorneyFeatureFlag } from '@modals/Admin/EditAttorneyFeatureFlag';
import { EditFeatureFlag } from '@modals/Admin/EditFeatureFlag';
import { AdminEditLicenseTranscriptUnlockTypeModal } from '@modals/Admin/EditLicenseTranscriptUnlockType';
import { AdminEditSubscriptionTranscriptUnlockTypeModal } from '@modals/Admin/EditSubscriptionTranscriptUnlockTypeModal';
import { AdminEditUserEmailModal } from '@modals/Admin/EditUserEmailModal';
import { AdminEditUserPhoneModal } from '@modals/Admin/EditUserPhoneModal';
import { AdminInviteUserModal } from '@modals/Admin/InviteUserModal';
import { AdminMoveJobToOrgWsModal } from '@modals/Admin/MoveJobToOrgWsModal';
import { NewASOnePlanModal } from '@modals/Admin/NewASOnePlanModal';
import { AddUserLicenseModal } from '@modals/ASOne/AddUserLicenseModal';
import { AdminConfirmSubscriptionCancellation } from '@modals/ASOne/AdminConfirmSubscriptionCancellation';
import { ChooseASOneSubscriptionModal } from '@modals/ASOne/ChooseASOneSubscriptionModal';
import { ConfirmSubscription } from '@modals/ASOne/ConfirmSubscription';
import { ConfirmSubscriptionCancellation } from '@modals/ASOne/ConfirmSubscriptionCancellation';
import { ConfirmSubscriptionUpgrade } from '@modals/ASOne/ConfirmSubscriptionUpgrade';
import { EditASOneSubscriptionModal } from '@modals/ASOne/EditASOneSubscriptionModal';
import { AutoScriptOneTutorialVideo } from '@modals/ASOneTutorialVideo';
import { AutoTopUpSettingsModal } from '@modals/AutoTopUpSettingsModal/AutoTopUpSettingsModal';
import { BackupFilesModal } from '@modals/BackupFilesModal';
import { TopUpCreditBalanceModal } from '@modals/Billing/TopUpCreditBalance';
import { TransactionStatusModal } from '@modals/Billing/TransactionStatusModal';
import { ChooseCloudLayoutModal } from '@modals/ChooseCloudLayoutModal';
import { ConfirmCloudLayoutResetModal } from '@modals/ConfirmCloudLayoutResetModal';
import { RegenerateWithLayoutModal } from '@modals/RegenerateWithLayoutModal';
import { ContactSales } from '@modals/ContactSales';
import { CreateAPIKeyModal } from '@modals/CreateAPIKeyModal';
import { CreateUserModal } from '@modals/CreateUserModal';
import { CustomConfirmationModal } from '@modals/common/confirmations/CustomConfirmationModal';
import { DeleteAPIKeyModal } from '@modals/common/confirmations/DeleteAPIKeyModal';
import { DeleteInvitationModal } from '@modals/common/confirmations/DeleteInvitationModal';
import { DeleteJobModal } from '@modals/common/confirmations/DeleteJobModal';
import { DeleteJobsModal } from '@modals/common/confirmations/DeleteJobsModal';
import { DeleteMemberModal } from '@modals/common/confirmations/DeleteMemberModal';
import { DeleteRepositoryModal } from '@modals/common/confirmations/DeleteRepositoryModal';
import { DeleteTeamModal } from '@modals/common/confirmations/DeleteTeamModal';
import { DeleteWorkspaceModal } from '@modals/common/confirmations/DeleteWorkspaceModal';
import { GenericConfirmationModal } from '@modals/common/confirmations/GenericConfirmation';
import { ResendInviteModal } from '@modals/common/confirmations/ResendInviteModal';
import { ResubmitJobModal } from '@modals/common/confirmations/ResubmitJobModal';
import { UpgradeToAIFeatures } from '@modals/common/confirmations/UpgradeToAIFeatures';
import { EditConcurrentJobsLimitModal } from '@modals/EditConcurrentJobsLimitModal';
import { AllJobsFiltersModal } from '@modals/filters/AllJobsFilters';
import { JobsListFiltersModal } from '@modals/filters/JobsListFilters';
import { AdminTransactionsFiltersModal } from '@modals/filters/AdminTransactionsFilters';
import { CasesFiltersModal } from '@modals/filters/CasesFilters';
import { JobsReportFiltersModal } from '@modals/filters/JobsReportFilters';
import { EditDeadlineModal } from '@modals/EditDeadlineModal';
import { EditLicenseTranscriptUnlockTypeModal } from '@modals/EditLicenseTranscriptUnlockTypeModal';
import { EditSubscriptionTranscriptUnlockTypeModal } from '@modals/EditSubscriptionTranscriptUnlockTypeModal';
import { GenericErrorModal } from '@modals/common/GenericErrorModal';
import { ImageUploadModal } from '@modals/ImageUpload';
import { InviteUserModal } from '@modals/InviteUserModal';
import { InviteUsersByCsvModal } from '@modals/InviteUsersByCsvModal';
import { EditJobCaseModal } from '@modals/JobDetails/EditJobCaseModal';
import { EditJobNotesModal } from '@modals/JobDetails/EditJobNotesModal';
import { EditJobTagsModal } from '@modals/JobDetails/EditJobTagsModal';
import { ReporterSummaryPreviewModal } from '@modals/JobDetails/ReporterSummaryPreviewModal';
import { JobHistory } from '@modals/JobHistory';
import { AssignJobModal } from '@modals/Jobs/AssignJobModal';
import { BulkCreateJobsModal } from '@modals/Jobs/BulkCreateJobsModal';
import { AdminBillingAccountRateHistoryModal } from '@modals/Admin/BillingAccountRatesHistory';
import { GetAssigneeModal } from '@modals/Jobs/GetAssigneeModal';
import { GetAssigneeWithoutCommentModal } from '@modals/Jobs/GetAssigneeWithoutCommentModal';
import { SelectCaseFiles } from '@modals/Jobs/SelectCaseFiles';
import { Modal } from '@modals/core-ui/Modal';
import { MonthPickerModal } from '@modals/MonthPicker';
import { MoveJobsToWSModal } from '@modals/MoveJobsToWSModal';
import { MoveJobToWSModal } from '@modals/MoveJobToWSModal';
import { NewOrganizationModal } from '@modals/NewOrganizationModal';
import { NewTeamModal } from '@modals/NewTeamModal';
import { NewVersionNotificationModal } from '@modals/NewVersionNotification';
import { NewWorkspaceModal } from '@modals/NewWorkspaceModal';
import { OfflineModal } from '@modals/Offline';
import { PaymentForm } from '@modals/PaymentForm';
import { PaymentMethodsHistory } from '@modals/PaymentMethodsHistory';
import { PeriodPickerModal } from '@modals/PeriodPicker';
import { PriceModal } from '@modals/PriceModal';
import { AssignRepositoryModal } from '@modals/Repositories/AssignRepositoryModal';
import { RepositoryBulkJobCreationModal } from '@modals/Repositories/BulkSubmitJobsModal';
import { SearchModal } from '@modals/Search';
import { StatusModal } from '@modals/common/StatusModal';
import { AddTeamToWorkspaceModal } from '@modals/Team/AddTeamToWorkspaceModal';
import { EditTeamMembersModal } from '@modals/Team/EditTeamMembersModal';
import { UnlockJobModal } from '@modals/UnlockJobModal';
import { UnlockJobModalFull } from '@modals/UnlockJobModalFull';
import { UpdateClassifiedErrorDescriptionModal } from '@modals/UpdateClassifiedErrorDescription';
import { UpdateLicenseBackupRecordingFlag } from '@modals/UpdateLicenseBackupRecordingFlag';
import { WhatsNewModal } from '@modals/WhatsNew';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useWebsocketContext } from '@providers/WebsocketProvider';
import { AdminAddNewAttorneysAccessModal } from '@modals/Admin/AddNewAttorneysAccess';
import React, { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import { useOfflineContext } from './OfflineProvider';
import { MarkJobReportedModal } from '@modals/MarkJobReportedModal';

type TProps = {
  children: React.ReactNode;
};

type TState = {
  isModalOpen?: boolean;
  closeModal: () => void;
  openModal: (modalName: keyof typeof ModalNamesEnum, modalProps?: object) => void;
};

const modalContextKey = Symbol.for('autoscript.modal-context');
type TModalContextGlobal = typeof globalThis & { [modalContextKey]?: React.Context<TState> };

const modalContextGlobal = globalThis as TModalContextGlobal;
const ModalContext =
  modalContextGlobal[modalContextKey] ??
  React.createContext<TState>({
    closeModal: () => {},
    openModal: () => {},
  });

modalContextGlobal[modalContextKey] = ModalContext;

// When we have a new version just update this key. It will pop again
const whatsNewLSKey = 'disableWhatsNew-2026-10-26';

export const ModalProvider = ({ children }: TProps) => {
  const { newVersionDeployed } = useWebsocketContext();
  const { isOffline } = useOfflineContext();
  const [openedModal, setOpenedModal] = React.useState('');
  const [modalProps, setModalProps] = React.useState<any>({});
  const [offLineModalOpen, setOffLineModalOpen] = React.useState(isOffline);
  const location = useLocation();
  const [whatsNewDisabled, setWhatsNewDisabled] = React.useState<string | null>(
    window.localStorage.getItem(whatsNewLSKey),
  );

  useEffect(() => {
    if (!newVersionDeployed) {
      return;
    }
    setOpenedModal(ModalNamesEnum.NewVersionNotification);
  }, [newVersionDeployed]);

  useEffect(() => {
    setOffLineModalOpen(isOffline);
  }, [isOffline]);

  const cancelCloseModal = () => {
    if (modalProps?.onCancel) {
      modalProps.onCancel();
    }
    setOpenedModal('');
    setModalProps(undefined);
  };

  const closeModal = () => {
    setOpenedModal('');
    setModalProps(undefined);
  };

  const openModal = (modalName: keyof typeof ModalNamesEnum, modalProps?: object) => {
    setModalProps(modalProps);
    setOpenedModal(modalName);
  };

  useEffect(() => {
    closeModal();
  }, [location.pathname]);

  if (offLineModalOpen) {
    return (
      <ModalContext.Provider
        value={{
          openModal,
          closeModal,
          isModalOpen:
            Boolean(openedModal) || offLineModalOpen || (!whatsNewDisabled && location.pathname.includes('/dashboard')),
        }}
      >
        {children}

        <Modal key="offline" isOpen={true} onClose={() => {}}>
          <OfflineModal onCancel={() => setOffLineModalOpen(false)} />
        </Modal>
      </ModalContext.Provider>
    );
  }

  if (!whatsNewDisabled && location.pathname.includes('/dashboard')) {
    const disableWhatsNew = () => {
      window.localStorage.setItem(whatsNewLSKey, 'true');
      setWhatsNewDisabled('true');
    };
    return (
      <ModalContext.Provider
        value={{
          openModal,
          closeModal,
          isModalOpen:
            Boolean(openedModal) || offLineModalOpen || (!whatsNewDisabled && location.pathname.includes('/dashboard')),
        }}
      >
        {children}
        <Modal key="whatsNew" isOpen={true} onClose={disableWhatsNew}>
          <WhatsNewModal onCancel={disableWhatsNew} />
        </Modal>

        <Toaster containerStyle={{ zIndex: '999999' }} position="bottom-right" reverseOrder={false} />
      </ModalContext.Provider>
    );
  }

  return (
    <ModalContext.Provider
      value={{
        openModal,
        closeModal,
        isModalOpen:
          Boolean(openedModal) || offLineModalOpen || (!whatsNewDisabled && location.pathname.includes('/dashboard')),
      }}
    >
      {children}
      <Modal key={openedModal} isOpen={!!openedModal} onClose={cancelCloseModal}>
        {openedModal === ModalNamesEnum.UpdateClassifiedErrorDescription ? (
          <UpdateClassifiedErrorDescriptionModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.MonthPicker ? <MonthPickerModal onCancel={closeModal} {...modalProps} /> : null}
        {openedModal === ModalNamesEnum.PeriodPicker ? (
          <PeriodPickerModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AllJobsFilters ? (
          <AllJobsFiltersModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.JobsListFilters ? (
          <JobsListFiltersModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.JobsReportFilters ? (
          <JobsReportFiltersModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminJobsReportFilters ? (
          <AllJobsFiltersModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.CasesFilters ? (
          <CasesFiltersModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminTransactionsFilters ? (
          <AdminTransactionsFiltersModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AutoScriptOneTutorialVideo ? (
          <AutoScriptOneTutorialVideo onCancel={closeModal} {...modalProps} />
        ) : null}

        {openedModal === ModalNamesEnum.AdminEditSetting ? (
          <AdminEditSettingModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminAddBalanceToBillingAccount ? (
          <AdminAddBalanceToBillingAccountModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminBillingAccountRate ? (
          <AdminBillingAccountRateModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminBillingAccountRatesHistory ? (
          <AdminBillingAccountRateHistoryModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminBillingAccountRatesEditor ? (
          <AdminBillingAccountRatesEditorModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminAIModelChoice ? (
          <AdminAIModelChoiceModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.PaymentMethodsHistory ? (
          <PaymentMethodsHistory onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ContactSales ? <ContactSales onCancel={closeModal} {...modalProps} /> : null}
        {openedModal === ModalNamesEnum.AddPaymentMethod ? (
          <PaymentForm onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.TopUpCreditBalance ? (
          <TopUpCreditBalanceModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.Status ? <StatusModal onSuccess={closeModal} {...modalProps} /> : null}
        {openedModal === ModalNamesEnum.TransactionStatus ? (
          <TransactionStatusModal onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.CreateUserModal ? (
          <CreateUserModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AddCourseStudent ? (
          <AddCourseStudentModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.PriceModal ? (
          <PriceModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.SearchModal ? (
          <SearchModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.UnlockJob ? (
          <UnlockJobModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}

        {openedModal === ModalNamesEnum.UnlockJobFull ? (
          <UnlockJobModalFull onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}

        {openedModal === ModalNamesEnum.DeleteJobModal ? (
          <DeleteJobModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.CustomConfirmationModal ? (
          <CustomConfirmationModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.DeleteJobsModal ? (
          <DeleteJobsModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ResubmitJobModal ? (
          <ResubmitJobModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.UpgradeToAIFeatures ? <UpgradeToAIFeatures onCancel={closeModal} /> : null}
        {openedModal === ModalNamesEnum.AdminResubmitJobModal ? (
          <AdminResubmitJobModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminApplyEnhancementModal ? (
          <AdminApplyEnhancementModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}

        {openedModal === ModalNamesEnum.AdminBulkResubmitJobsModal ? (
          <AdminBulkResubmitJobsModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}

        {openedModal === ModalNamesEnum.AdminLeaveOrganizationModal ? (
          <AdminLeaveOrganizationModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}

        {openedModal === ModalNamesEnum.AdminLlmCallsModal ? (
          <AdminLlmCallsModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminBackupFilesModal ? (
          <AdminBackupFilesModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.BackupFilesModal ? (
          <BackupFilesModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.UpdateLicenseBackupRecordingFlag ? (
          <UpdateLicenseBackupRecordingFlag onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminMoveJobModal ? (
          <AdminMoveJobToOrgWsModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminRefundJobModal ? (
          <AdminRefundJobModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.InviteUserModal ? (
          <InviteUserModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.InviteUsersByCsvModal ? (
          <InviteUsersByCsvModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.DeleteInvitationModal ? (
          <DeleteInvitationModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminInviteUserModal ? (
          <AdminInviteUserModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.NewWorkspaceModal ? (
          <NewWorkspaceModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.DeleteAPIKey ? (
          <DeleteAPIKeyModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.CreateAPIKey ? (
          <CreateAPIKeyModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.DeleteWorkspaceModal ? (
          <DeleteWorkspaceModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AssignJobModal ? (
          <AssignJobModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.GetAssigneeModal ? (
          <GetAssigneeModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.GetAssigneeWithoutCommentModal ? (
          <GetAssigneeWithoutCommentModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AddUserLicenseModal ? (
          <AddUserLicenseModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditJobNotesModal ? (
          <EditJobNotesModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditJobCaseModal ? (
          <EditJobCaseModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditJobTagsModal ? (
          <EditJobTagsModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditDeadline ? (
          <EditDeadlineModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.MoveJobToWSModal ? (
          <MoveJobToWSModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditLicenseTranscriptUnlockType ? (
          <EditLicenseTranscriptUnlockTypeModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditSubscriptionTranscriptUnlockType ? (
          <EditSubscriptionTranscriptUnlockTypeModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminEditLicenseTranscriptUnlockType ? (
          <AdminEditLicenseTranscriptUnlockTypeModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminEditSubscriptionTranscriptUnlockType ? (
          <AdminEditSubscriptionTranscriptUnlockTypeModal
            onCancel={closeModal}
            onSuccess={closeModal}
            {...modalProps}
          />
        ) : null}
        {openedModal === ModalNamesEnum.AdminEditJobTranscriptUnlockType ? (
          <AdminEditJobTranscriptUnlockTypeModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ChooseCloudLayout ? (
          <ChooseCloudLayoutModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.RegenerateWithLayout ? (
          <RegenerateWithLayoutModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ConfirmCloudLayoutReset ? (
          <ConfirmCloudLayoutResetModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AddWSToTeamModal ? (
          <AddWSToTeamModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.MoveJobsToWSModal ? (
          <MoveJobsToWSModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.JobHistory ? <JobHistory onCancel={closeModal} {...modalProps} /> : null}
        {openedModal === ModalNamesEnum.ReporterSummaryPreviewModal ? (
          <ReporterSummaryPreviewModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ImageUploadModal ? (
          <ImageUploadModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.NewOrganizationModal ? (
          <NewOrganizationModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditTeamMembersModal ? (
          <EditTeamMembersModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AddTeamToWorkspaceModal ? (
          <AddTeamToWorkspaceModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.DeleteRepositoryModal ? (
          <DeleteRepositoryModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.DeleteMemberModal ? (
          <DeleteMemberModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.DeleteTeamModal ? (
          <DeleteTeamModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.NewTeamModal ? (
          <NewTeamModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.GenericErrorModal ? (
          <GenericErrorModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.GenericConfirmation ? (
          <GenericConfirmationModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AcceptBackupRecordingTerms ? (
          <AcceptBackupRecordingTermsModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.NewVersionNotification ? (
          <NewVersionNotificationModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AssignRepositoryModal ? (
          <AssignRepositoryModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.SelectCaseFiles ? (
          <SelectCaseFiles onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ChooseASOneSubscriptionModal ? (
          <ChooseASOneSubscriptionModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminChooseASOneSubscriptionModal ? (
          <AdminChooseASOneSubscriptionModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditASOneSubscriptionModal ? (
          <EditASOneSubscriptionModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminEditASOneSubscriptionModal ? (
          <AdminEditASOneSubscriptionModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ConfirmSubscription ? (
          <ConfirmSubscription onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ConfirmSubscriptionUpgrade ? (
          <ConfirmSubscriptionUpgrade onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminConfirmSubscription ? (
          <AdminConfirmSubscription onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ConfirmSubscriptionCancellation ? (
          <ConfirmSubscriptionCancellation onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminConfirmSubscriptionCancellation ? (
          <AdminConfirmSubscriptionCancellation onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AdminCloneJobModal ? (
          <AdminCloneJobModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AddNewASOnePlan ? (
          <NewASOnePlanModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditASOnePlan ? (
          <EditASOnePlanModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.CreateNewSMSCountry ? (
          <CreateNewSMSCountry onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.SsoProviderModal ? (
          <SsoProviderModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.CreateNewFeatureFlag ? (
          <CreateNewFeatureFlag onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditFeatureFlag ? (
          <EditFeatureFlag onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.CreateNewAttorneyFeatureFlag ? (
          <CreateNewAttorneyFeatureFlag onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditAttorneyFeatureFlag ? (
          <EditAttorneyFeatureFlag onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.CreateNewWhitelistNumber ? (
          <CreateNewWhitelistNumber onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.RepositoryBulkJobCreation ? (
          <RepositoryBulkJobCreationModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.BulkJobCreation ? (
          <BulkCreateJobsModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AddAdminTransactionModal ? (
          <AddAdminTransactionModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditUserPhone ? (
          <AdminEditUserPhoneModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditUserEmail ? (
          <AdminEditUserEmailModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.EditConcurrentJobsLimit ? (
          <EditConcurrentJobsLimitModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.ResendInvitationModal ? (
          <ResendInviteModal onCancel={closeModal} {...modalProps} />
        ) : null}
        {openedModal === ModalNamesEnum.AutoTopUpSettings ? (
          <AutoTopUpSettingsModal onCancel={closeModal} {...modalProps} />
        ) : null}

        {openedModal === ModalNamesEnum.AdminAddNewAttorneysAccess ? (
          <AdminAddNewAttorneysAccessModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}

        {openedModal === ModalNamesEnum.AddNewAttorneysAccess ? (
          <AddNewAttorneysAccessModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}

        {openedModal === ModalNamesEnum.AdminMarkJobReported ? (
          <MarkJobReportedModal onCancel={closeModal} onSuccess={closeModal} {...modalProps} />
        ) : null}
      </Modal>

      <Toaster containerStyle={{ zIndex: '999999' }} position="bottom-right" reverseOrder={false} />
    </ModalContext.Provider>
  );
};

export const useModalContext = () => React.useContext(ModalContext);
